module.exports = __webpack_public_path__ + "img/lotto-dl-ladl-1400x400.84c49797.jpg";